module.exports = __webpack_public_path__ + "static/img/product-code.ddd744dc.png";